import "./Card.css";

interface Props {
  title: string;
  value: number;
  description?: string;
  className?: string;
  backgroundColor?: string;
  trend?: "up" | "down" | "neutral";
  icon?: React.ReactNode;
  isManey?: boolean;
}

/**
 *
 * To change the style of the card, you can use the className prop or the backgroundColor prop.
 *  className="mc-card-success" : for success color
 *  className="mc-card-danger" : for danger color
 *  className="mc-card-warning" : for warning color
 *  className="mc-card-info" : for info color
 *  className="mc-card-neutral" : for neutral color
 */
export const Card = ({
  title,
  value,
  description,
  className,
  backgroundColor,
  trend,
  icon,
  isManey = true,
}: Props) => {
  return (
    <div
      className={`mc-card ${className || ""}`}
      style={backgroundColor ? { backgroundColor } : undefined}
    >
      <div className="mc-card-header">
        <div className="mc-card-title-wrapper">
          {icon && <div className="mc-card-icon">{icon}</div>}
          <h3 className="mc-card-title">{title}</h3>
        </div>
        {trend && (
          <div className={`mc-card-trend mc-card-trend-${trend}`}>
            {trend === "up" && "↑"}
            {trend === "down" && "↓"}
            {trend === "neutral" && "→"}
          </div>
        )}
      </div>

      <div className="mc-card-body">
        <div className="mc-card-value-wrapper">
          <h2 className="mc-card-value">
            {isManey
              ? value.toLocaleString("fr-TN", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : value}
          </h2>
          <span className="mc-card-currency">{isManey ? "$" : ""}</span>
        </div>
        {description && <p className="mc-card-description">{description}</p>}
      </div>

      <div className="mc-card-accent"></div>
    </div>
  );
};
